import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import { generateImgSrc } from './index'

export default function Zoomable({
  src,
  type,
  height,
  width,
  folder,
  quality,
  fullRes,
  alt,
  className,
}) {
  return (
    <Zoom className={className}>
      <img
        src={generateImgSrc({ src, type, height, width, folder, quality, fullRes })}
        alt={alt}
        width={600}
        height={400}
        loading="lazy"
      />
    </Zoom>
  )
}
